/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { ProgressBarAnimated } from '@intelie/ui'
import moment, { Moment } from 'moment'

import i18n from 'live/services/i18n'
import LiveSelect from 'live/components/forms/ui/select'
import globalNotification from 'live/services/global-notification'
import SubmitOrCancel from 'live/components/forms/ui/submit-or-cancel'

import { Period, Template } from '../../../types'
import { getTemplate } from '../../../services/template'
import { TemplateFormProps } from '../TemplateFormRenderer'
import { FormRenderer } from '../../../formBuilder/components/FormRenderer'
import { AnnotationEmptyData, FormContainer, StyledSection } from '../../styles'

interface EditAnnotationProps extends TemplateFormProps {
    submitFormData: (data: Record<string, unknown>, template: Template, period: Period) => void
}

const EditAnnotation: React.FC<EditAnnotationProps> = (props: EditAnnotationProps) => {
    const [template, setTemplate] = useState<Template>()
    const [period, setPeriod] = useState<Period>({ begin: props.event.begin, end: props.event.end })
    const [annotationData, setAnnotationData] = useState<Record<string, unknown>>(props.event.data)
    const [loadingTemplate, setLoadingTemplate] = useState<boolean>(true)

    const handleOnChangePeriod = (value: Moment, key: 'begin' | 'end'): void => {
        setPeriod(prevState => ({ ...prevState, [key]: moment(value).valueOf() }))
    }

    useEffect(() => {
        const fetchTemplate = async (): Promise<void> => {
            try {
                const template = await getTemplate(props.event.templateId)

                setTemplate(template)
            } catch (error) {
                globalNotification.error(i18n(error.message), 5)
            }

            setLoadingTemplate(false)
        }

        fetchTemplate()
    }, [])

    return (
        <>
            {loadingTemplate ? (
                <ProgressBarAnimated />
            ) : template ? (
                <>
                    <FormContainer>
                        <div className="template-select">
                            <LiveSelect
                                disabled
                                label={i18n('Annotation template')}
                                value={{ label: template.alias, value: template.id }}
                            />
                        </div>
                        {template && period.begin && (
                            <FormRenderer
                                mode="edit"
                                period={period}
                                data={annotationData}
                                schema={JSON.parse(template.schema) as FormSchema}
                                onChange={data => setAnnotationData(data)}
                                onChangePeriod={handleOnChangePeriod}
                            />
                        )}
                    </FormContainer>
                    {props.showActions && (
                        <StyledSection>
                            <SubmitOrCancel
                                btnsClassName="btn-lg btn-bold"
                                disabled={!template}
                                saving={false}
                                saved={false}
                                onSubmit={() => props.submitFormData(annotationData, template, period)}
                                onCancel={props.onHide}
                            />
                        </StyledSection>
                    )}
                </>
            ) : (
                <AnnotationEmptyData title={i18n('No template found')} icon="far fa-empty-set" />
            )}
        </>
    )
}

export default EditAnnotation
